export default __webpack_public_path__ + "static/media/mechanical2_keyboard.4ff5a4e1.jpg";